import { hydrateRoot, createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

const rootEl = document.getElementById("root")!;
const app = (
  <HelmetProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </HelmetProvider>
);

if (rootEl.hasChildNodes()) {
  hydrateRoot(rootEl, app);
} else {
  createRoot(rootEl).render(app);
}

// Drop the static LCP shell as soon as React has painted (don't wait for hero effect).
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    document.getElementById("lcp-shell")?.remove();
  });
});
window.setTimeout(() => {
  document.getElementById("lcp-shell")?.remove();
}, 1500);
